import {create} from 'zustand';
type DeskStock={symbol:string;name:string};
type Client={symbol:string;onPick:(symbol:string)=>void};
interface State {
 deskStock:DeskStock|null; openDesk:(stock:DeskStock)=>void; closeDesk:()=>void;
 open:boolean; opened:boolean; keyboardOwned:boolean; openToken:number;
 clients:Record<string,Client>; activeClient:string|null; selectedSymbol:string;
 setOpen:(open:boolean)=>void; setKeyboard:(owned:boolean)=>void;
 register:(id:string,client:Client)=>void; unregister:(id:string)=>void; activate:(id:string)=>void; pick:(symbol:string)=>void;
}
/** One detached editor across routes; only the last active desk receives a picked symbol. */
export const useGlobalVault=create<State>((set,get)=>({
 deskStock:null,openDesk:deskStock=>set({deskStock,keyboardOwned:false}),closeDesk:()=>set({deskStock:null}),
 open:false,opened:false,keyboardOwned:false,openToken:0,clients:{},activeClient:null,selectedSymbol:'',
 setOpen:open=>set(s=>({open,opened:s.opened||open,keyboardOwned:false,openToken:s.openToken+(open?1:0)})),
 setKeyboard:keyboardOwned=>set({keyboardOwned}),
 register:(id,client)=>set(s=>({clients:{...s.clients,[id]:client},activeClient:s.activeClient??id})),
 unregister:id=>set(s=>{const clients={...s.clients};delete clients[id];return {clients,activeClient:s.activeClient===id?Object.keys(clients).at(-1)??null:s.activeClient};}),
 activate:id=>{if(get().clients[id])set({activeClient:id,keyboardOwned:false});},
 pick:symbol=>{const s=get();set({selectedSymbol:symbol});s.clients[s.activeClient??'']?.onPick(symbol);},
}));

/** Guard background window-level shortcuts while the global editor owns the keyboard. */
export function globalVaultBlocksKeyboard(scope?:Element|null){
 const s=useGlobalVault.getState();
 // A floating chart may leave focus on body. Background maps must still yield Delete/Backspace.
 if(s.deskStock&&!s.keyboardOwned)return true;
 return s.open&&s.keyboardOwned&&!scope?.closest('[data-global-vault-window]');
}
